export class Funcionario {
  constructor({
    id,
    nome,
    matricula,
    biometria,
    biometria_facial,
    idTabela,
    centroCusto,
    centroCustoCode,
    centroCustoName,
  }) {
    this.id = id;
    this.nome = nome;
    this.matricula = matricula;
    this.biometria = biometria;
    this.biometria_facial = biometria_facial;
    this.idTabela = idTabela;
    this.centroCusto = centroCusto;
    this.centroCustoCode = centroCustoCode;
    this.centroCustoName = centroCustoName;
  }
}
